export default __webpack_public_path__ + "26e763f.png";